/** @module builtins/Navigator */

if (typeof window !== 'undefined') {
    /**
     * A central place for navigator.getUserMedia on all platforms.
     * @type {Function}
     */
    window.navigator.getMedia =
        window.navigator.getUserMedia ||
        window.navigator.webkitGetUserMedia ||
        window.navigator.mozGetUserMedia ||
        window.navigator.msGetUserMedia;
}
